import React from "react";
import { Box, Typography, Button, useTheme } from "@mui/material";

const CountdownBar = ({ seconds, total, onSkip, onCancel, onPrev }) => {
  const theme = useTheme();
  const tc = theme.customColors;
  const fillPct = Math.round(((total - seconds) / total) * 100);
  return (
    <Box
      sx={{
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 20,
        borderTop: `1px solid ${tc.border.subtle}`,
        bgcolor: tc.background.cardHeader,
        px: 3.5,
        pt: 1.25,
        pb: 1.5,
      }}
    >
      <Box
        sx={{
          height: 6,
          borderRadius: "100px",
          bgcolor: theme.palette._blue ? theme.palette._blue.light : "rgba(25,118,210,0.1)",
          overflow: "hidden",
          mb: 1,
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: `${fillPct}%`,
            borderRadius: "100px",
            background: "linear-gradient(90deg, #4a7bff 0%, #7b9dff 100%)",
            transition: "width 0.92s linear",
            boxShadow: "0 0 8px rgba(74,123,255,0.35)",
          }}
        />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Typography sx={{ fontSize: "0.78rem", color: tc.text.secondary, fontVariantNumeric: "tabular-nums" }}>
          Moving to next evidence in{" "}
          <Box component="span" sx={{ fontWeight: 700, color: theme.palette.primary.main, display: "inline-block", minWidth: "1ch", textAlign: "center" }}>
            {seconds}
          </Box>
          s
        </Typography>
        <Box sx={{ display: "flex", gap: 0.5 }}>
          {onPrev && (
            <Button
              size="small"
              onClick={onPrev}
              sx={{ textTransform: "none", fontWeight: 500, fontSize: "0.78rem", color: tc.text.secondary, minWidth: 0, px: 1.25, py: 0.25, borderRadius: 1, "&:hover": { bgcolor: tc.background.hover } }}
            >
              ← Prev
            </Button>
          )}
          <Button
            size="small"
            onClick={onCancel}
            sx={{ textTransform: "none", fontWeight: 500, fontSize: "0.78rem", color: tc.text.secondary, minWidth: 0, px: 1.25, py: 0.25, borderRadius: 1, "&:hover": { bgcolor: tc.background.hover } }}
          >
            Stay
          </Button>
          <Button
            size="small"
            onClick={onSkip}
            sx={{ textTransform: "none", fontWeight: 600, fontSize: "0.78rem", color: theme.palette.primary.main, minWidth: 0, px: 1.25, py: 0.25, borderRadius: 1, "&:hover": { bgcolor: theme.palette._blue?.light || "rgba(25,118,210,0.08)" } }}
          >
            Next →
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default CountdownBar;
